import { render, staticRenderFns } from "./DeductionsPlanEdit.vue?vue&type=template&id=a11840e6&scoped=true&"
import script from "./DeductionsPlanEdit.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11840e6",
  null
  
)

export default component.exports